import ajax from '@/utils/ajax'
import customerAjax from '@/utils/customerAjax'
import logAjax from '@/utils/logAjax'
import dashboardApi from './dashboardApi'
import analysisApi from './analysisApi'
import CantonFairApi from './CantonFairApi'
import CreditApi from './CreditApi'
import businessApi from './businessApi'
import aiIntelligence from './aiIntelligence'
import AIGPT from './AIGPT'

import axios from 'axios'
let CancelToken = axios.CancelToken
window.cancel = {}
export default {
  user: {
    // 获取自定义的AI智能字段
    getAiSetting(data) {
      return customerAjax({
        url: 'gt/getAiSetting',
        method: 'POST',
        data: data
      })
    },
    // 设置自定义的AI智能字段
    saveAiSetting(data) {
      return customerAjax({
        url: 'gt/saveAiSetting',
        method: 'POST',
        data: data
      })
    },
    getShowOpenButton(params) {
      return ajax({
        url: 'gt6/analysisReport/getShowOpenButton',
        method: 'GET',
        params
      })
    },
    //账号中心数据更新缓存
    getResetUserCache() {
      return ajax({
        url: 'gt6/user/resetUserCache',
        method: 'GET'
      })
    },
    //订阅
    subscribeAnalysis(data) {
      return ajax({
        url: 'gt6/public/subscribeAnalysis',
        method: 'POST',
        data: data
      })
    },
    //账号中心数据更新缓存
    getResetUserCache() {
      return ajax({
        url: 'gt6/user/resetUserCache',
        method: 'GET'
      })
    },
    //获取当前可配置的字段
    getCustomData() {
      return ajax({
        url: 'gt6/user/getCustomData',
        method: 'GET'
      })
    },
    getUserInfo() {
      return ajax({
        url: 'gt6/user/getUserInfo',
        method: 'POST'
      })
    },
    getUserInfoNoCache() {
      return ajax({
        url: 'gt6/user/getUserInfoNoCache',
        method: 'GET'
      })
    },
    getRules() {
      return ajax({
        url: 'gt6/user/getRules',
        method: 'GET'
      })
    },
    getChildAccountOptions() {
      return ajax({
        url: 'gt6/user/getChildAccountOptions',
        method: 'GET'
      })
    },
    getChildAccountOptions2() {
      return ajax({
        url: 'gt6/user/getChildAccountOptions2',
        method: 'GET'
      })
    },
    getDownloadDisable() {
      return ajax({
        url: 'gt6/user/getDownloadDisable',
        method: 'GET'
      })
    },
    //获取当前话素
    getCurrentSayData(params) {
      return ajax({
        url: 'gt6/tool/getChatSendData',
        method: 'GET',
        params
      })
    },
    getUrl(data) {
      return customerAjax({
        url: 'weixin/geturl',
        method: 'POST',
        data: data
      })
    },
    loginout() {
      return ajax({
        url: 'business/user/loginout',
        method: 'POST'
      })
    },
  //获取当前子账号的接口
    getChildAccount(data) {
      return customerAjax({
        url: 'user/GetSelfAndChildCustomerList',
        method: 'POST',
        data
      })
    },
    // 通过chrome_token获取产品token
    getTokenByBrToken(data) {
      return customerAjax({
        url: '/user/getTokenByBrToken',
        method: 'POST',
        data
      })
    },
  },
  public: {
    // public/resetTranslate 重置单个语种翻译
    resetTranslate(data) {
      return ajax({
        url: 'gt6/public/resetTranslate',
        method: 'POST',
        data
      })
    },
    // 获取某个国家信息
    getOneCountryInfo(params) {
      return ajax({
        url: 'gt6/public/getCountryInfo',
        method: 'GET',
        params
      })
    },
    // /api/gt/public/getCutDimensionNumber 获取用户切换维度
    getCutDimensionNumber(params) {
      return ajax({
        url: 'gt6/public/getCutDimensionNumber',
        method: 'GET',
        params
      })
    },
    // 1、特易搜搜-企业详情页-贸易记录折线/柱状图 2、特易搜搜-企业详情页-采供链透视图 3、贸易情报-市场趋势-折线/柱状图4、贸易情报-采购商分析/新增采购商分析/供应商分析/新增供应商分析-折线/饼状图
    // /api/gt/public/addCutDimension 保存用户切换维度
    addCutDimension(data) {
      return ajax({
        url: 'gt6/public/addCutDimension',
        method: 'POST',
        data
      })
    },
    //获取成功状态的接口
    refresh(params) {
      return ajax({
        url: 'business/pay/wxpay/refresh',
        method: 'GET',
        params
      })
    },
    rechargeCode(params) {
      return ajax({
        url: 'business/pay/order/recharge',
        method: 'GET',
        params
      })
    },
    rechargeProducts(params) {
      return ajax({
        url: 'business/pay/order/rechargeProducts',
        method: 'GET',
        params
      })
    },
    //获取消息通知
    getMesageList(data) {
      return ajax({
        url: 'gt6/public/getMessageNotify',
        method: 'POST',
        data
      })
    },
    //获取当前登录的状态
    getLoginStatus(data) {
      return ajax({
        url: 'business/user/loginalert',
        method: 'POST',
        data
      })
    },
    //重新获取  token
    relogin(data) {
      return ajax({
        url: 'business/user/relogin',
        method: 'POST',
        data
      })
    },
    //获取企业行业分类数据
    getCompanyIndustryCateGory() {
      return ajax({
        url: 'gt6/public/getCompanyIndustryCateGory',
        method: 'GET',
      })
    },
    //获取起始港和目的港的option
    getPortOptionData(data) {
      return ajax({
        url: 'gt6/public/getPortsByIds',
        method: 'POST',
        data
      })
    },
    //获取翻译接口
    getTranslate(data) {
      return ajax({
        url: 'gt6/public/getTranslate',
        method: 'POST',
        data
      })
    },
    getVersionList() {
      return ajax({
        url: 'gt6/user/getVersionList',
        method: 'GET',
      })
    },
    versionCut(params) {
      return ajax({
        url: 'gt6/user/versionCut',
        method: 'GET',
        params
      })
    },
    getCountryIesDaterange(params) {
      return ajax({
        url: 'gt6/public/getCountryIesDaterange',
        method: 'GET',
        params
      })
    },
    getAllHsCode() {
      return ajax({
        url: 'gt6/product/getAllHsCode',
        method: 'GET',
      })
    },
    getProductCountryOptions() {
      return ajax({
        url: 'gt6/product/getProductCountryOptions',
        method: 'GET',
      })
    },
    getAnalysisQueryTradeDate(params) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisQueryTradeDate',
        method: 'GET',
        params
      })
    },
    getFlags() {
      return ajax({
        url: 'gt6/public/getCountryFlags',
        method: 'GET'
      })
    },
    getCountryOptions(params) {
      return ajax({
        url: 'gt6/public/getCountryOptions',
        method: 'GET',
        params
      })
    },
    getPermissionCountryOptions() {
      return ajax({
        url: 'gt6/public/getPermissionCountryOptions',
        method: 'GET'
      })
    },
    getTrendCountryOptions() {
      return ajax({
        url: 'gt6/trend/getTrendCountryOptions',
        method: 'GET'
      })
    },
    getTrendProductData(params) {
      return ajax({
        url: 'gt6/trend/getTrendProductData',
        method: 'GET',
        params
      })
    },
    getCompanyAnaysisData(params) {
      return ajax({
        url: 'gt6/search/getCompanyAnaysisData',
        method: 'GET',
        params
      })
    },
    getHsCodeData(params) {
      return ajax({
        url: 'gt6/public/getHsCodeData',
        method: 'GET',
        params
      })
    },
    getHsCodeOptionsPrefix(params) {
      return ajax({
        url: 'gt6/public/getHsCodeOptionsPrefix',
        method: 'GET',
        params,
        cancelToken: new CancelToken((e) => {
          window.cancel.getHsCodeOptionsPrefix = e
        })
      })
    },
    getHsCodeOptions(params) {
      return ajax({
        url: 'gt6/public/getHsCodeOptions',
        method: 'GET',
        params,
        cancelToken: new CancelToken((e) => {
          window.cancel.getHsCodeOptions = e
        })
      })
    },
    getTradeDateRangeOptions() {
      return ajax({
        url: 'gt6/public/getTradeDateRangeOptions',
        method: 'GET'
      })
    },
    getTransportTypeOptions() {
      return ajax({
        url: 'gt6/public/getTransportTypeOptions',
        method: 'GET'
      })
    },
    getDeparturePortOptions(params) {
      return ajax({
        url: 'gt6/public/getPorts',
        method: 'GET',
        params
      })
    },
    getDestinationPortOptions(params) {
      return ajax({
        url: 'gt6/public/getPorts',
        method: 'GET',
        params
      })
    },
    getDataTypeOptions() {
      return ajax({
        url: 'gt6/public/getDataTypeOptions',
        method: 'GET'
      })
    },
    getDataTypesByCountry(params) {
      return ajax({
        url: 'gt6/trade/getDataTypesOptionsByCountry',
        method: 'GET',
        params,
        cancelToken: new CancelToken((e) => {
          window.cancel.getDataTypesOptionsByCountry = e
        })
      })
    },
    getHsCodeOptionsWithKeyword(params) {
      return ajax({
        url: 'gt6/public/getHsCodeOptionsWithKeyword',
        method: 'GET',
        params
      })
    },
    translate(data) {
      return ajax({
        url: 'gt6/public/translate',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.translate = e
        })
      })
    },
    getAnalysisITradeType(data) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisITradeType',
        method: 'POST',
        data
      })
    },
    getAnalysisITradeTypeTable(data) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisITradeTypeTable',
        method: 'POST',
        data
      })
    },
    getAnalysisIndustryDetail(data) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisIndustryDetail',
        method: 'POST',
        data
      })
    },
    getHsCodePriceData(data) {
      return ajax({
        url: 'gt6/trendChina/getHsCodePriceData',
        method: 'POST',
        data
      })
    }
  },
  home: {
    getHomeData() {
      return ajax({
        url: 'gt6/public/getHomeDataInfo',
        method: 'GET'
      })
    }
  },
  dashboard: {
    ...dashboardApi,
    changePassword(data) {
      return ajax({
        url: 'business/account/changePassword',
        method: 'POST',
        data
      })
    },
    saveInterestedCountry(data) {
      return ajax({
        url: 'business/gt/saveInterestedCountry',
        method: 'POST',
        data
      })
    },
    bindWeiXin(data) {
      return ajax({
        url: 'business/account/bindWeiXin',
        method: 'POST',
        data: data
      })
    },
    getSystemMsg() {
      return ajax({
        url: 'gt6/user/getSystemMsg',
        method: 'GET',
      })
    },
    getUpdateData(data) {
      return customerAjax({
        url: 'update/getUpdateData',
        method: 'POST',
        data
      })
    },
    getUserInfo(data) {
      return ajax({
        url: 'business/account/getUserInfo',
        method: 'POST',
        data
      })
    },
    saveMyDataCorrection(data) {
      // 变更接口/api/help/public/saveMyDataCorrection
      return ajax({
        url: 'help/public/saveMyDataCorrection',
        method: 'POST',
        data
      })
    },
    getSummaryData() {
      return ajax({
        url: 'gt6/dashboard/getSummaryData',
        method: 'GET'
      })
    },
    getCollectList(params) {
      return ajax({
        url: 'gt6/dashboard/getCollectList',
        method: 'GET',
        params
      })
    },
    pinnedCollect(data) {
      return ajax({
        url: 'gt6/dashboard/pinnedCollect',
        method: 'POST',
        data
      })
    },
    getCollectLabels(params) {
      return ajax({
        url: 'gt6/dashboard/getCollectCompanyLabels',
        method: 'GET',
        params
      })
    },
    //获取CRM标签
    getCrmLabel(data) {
      return ajax({
        url: 'gt6/public/getCrmLabel',
        method: 'POST',
        data
      })
    },
    //添加线索
    addClue(data) {
      return ajax({
        url: 'gt6/public/addClue',
        method: 'POST',
        data
      })
    },
    // 添加CRM标签
    addCrmLabel(data) {
      return ajax({
        url: 'gt6/public/addCrmLabel',
        method: 'POST',
        data
      })
    },
    getCollectCountryOptions(params) {
      return ajax({
        url: 'gt6/dashboard/getCollectCompanyCountryOptions',
        method: 'GET',
        params
      })
    },
    getNoticeList() {
      return ajax({
        url: 'gt6/dashboard/getNoticeList',
        method: 'GET'
      })
    },
    getExportCompanyLogs(params) {
      return ajax({
        url: 'gt6/search/getExportCompanyLogs',
        method: 'GET',
        params
      })
    },
    getDownloadTradeDataLogs(params) {
      return ajax({
        url: 'gt6/trade/getDownloadTradeDataLogs',
        method: 'GET',
        params
      })
    }
  },
  search: {
    // /api/gt/search/checkMapPower 检查地图权限
    checkMapPower(data) {
      return ajax({
        url: 'gt6/search/checkMapPower',
        method: 'POST',
        data
      })
    },
    // /api/gt/search/saveMapUseLog 保存地图使用记录
    saveMapUseLog(data) {
      return ajax({
        url: 'gt6/search/saveMapUseLog',
        method: 'POST',
        data
      })
    },
    getSearchResult (params) {
      return ajax({
        url: 'sou/search/searchCompanys',
        method: 'GET',
        params
      })
    },
    getSearchProgress (params) {
      return ajax({
        url: 'sou/search/searchprogress',
        method: 'GET',
        params
      })
    },
    // 开启进度条
    startSearch (params) {
      return ajax({
        url: 'sou/search/dosearch',
        method: 'GET',
        params
      })
    },
    getCompanyContacts (params) {
      return ajax({
        url: 'sou/search/getCompanyContacts',
        method: 'GET',
        params
      })
    },
    //保存企业网址
    saveWebsite(data) {
      return ajax({
        url: 'gt6/search/saveWebsite',
        method: 'POST',
        data
      })
    },
    //获取公司详情-贸易记录图表(统计)
    getCompanyTradeData(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeData',
        method: 'POST',
        data
      })
    },
    //特意搜搜高级搜索总数
    searchCount(data) {
      return ajax({
        url: 'gt6/search/getPreSearchCount',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.companyPreSearchCount = e
        })
      })
    },
    getHistorySearchList(data) {
      return ajax({
        url: 'gt6/search/getHistorySearchList',
        method: 'POST',
        data
      })
    },
    //历史记录删除
    deleteHistorySearch(params) {
      return ajax({
        url: 'gt6/search/deleteHistorySearch',
        method: 'GET',
        params
      })
    }
  },
  company: {
    // 企业搜索维度排序制定
    getSearchPinned(params) {
      return ajax({
        url: 'gt6/search/pinned',
        method: 'GET',
        params
      })
    },
    // 企业搜索维度排序制定
    setSearchPinned(data) {
      return ajax({
        url: 'gt6/search/pinned',
        method: 'POST',
        data
      })
    },
    // 广交会-国家数据
    getSmartBusinessCountry(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessCountry',
        method: 'GET',
        params
      })
    },
    getSmartBusinessSyncResult(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessSyncResult',
        method: 'GET',
        params
      })
    },
    getSmartBusinessData(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessData',
        method: 'GET',
        params
      })
    },
    smartBusinessSearch(data) {
      return ajax({
        url: 'gt6/search/smartBusinessSearch',
        method: 'POST',
        data
      })
    },
    // /api/gt/public/saveSmartBusiness 智能商机列表添加接口
    saveSmartBusiness(data) {
      return ajax({
        url: 'gt6/search/saveSmartBusiness',
        method: 'POST',
        data
      })
    },
    // //api/gt/public/getSmartBusinessInfo 智能商机获取详情接口
    getSmartBusinessInfo(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessInfo',
        method: 'GET',
        params
      })
    },
    // /api/gt/search/getMapByAddress 获取谷歌地图数据
    getMapByAddress(data) {
      return ajax({
        url: 'gt6/search/getMapByAddress',
        method: 'POST',
        data
      })
    },
    // /api/gt/search/getBusinessInfo 公司详情页-获取商业数据
    getBusinessInfo(params) {
      return ajax({
        url: 'gt6/search/getBusinessInfo',
        method: 'GET',
        params
      })
    },
    // /api/gt/search/getBusinessData 获取商业企业数据
    getBusinessData(params) {
      return ajax({
        url: 'gt6/search/getBusinessData',
        method: 'GET',
        params
      })
    },
    // /api/gt/search/getCompanyContactCount 获取企业联系人数量汇总
    getCompanyContactCount(params) {
      return ajax({
        url: 'gt6/search/getCompanyContactCount',
        method: 'GET',
        params
      })
    },
    // /api/gt/search/getCompanyKeywordAndHsCodeOptions 获取产品关键词/HS编码下拉数据
    getCompanyKeywordAndHsCodeOptions(data) {
      return ajax({ 
        url: 'gt6/search/getCompanyKeywordAndHsCodeOptions',
        method: 'POST',
        data
      })
    },
    // /api/gt/search/dissolveMerge
    // 解散合并企业
    dissolveMerge(params) {
      return ajax({
        url: 'gt6/search/dissolveMerge',
        method: 'GET',
        params
      })
    },
    // 分享企业合并
    mergeShareCompany(data) {
      return ajax({
        url: 'gt6/search/mergeShareCompany',
        method: 'POST',
        data
      })
    },
    // 企业详情-获取相似企业
    getSimilarCompany(data) {
      return ajax({
        url: 'gt6/search/getSimilarCompany',
        method: 'POST',
        data
      })
    },
    // 企业详情-获取分享数据
    getShareData(params) {
      return ajax({
        url: 'gt6/search/getShareData',
        method: 'GET',
        params
      })
    },
    // 获取贸易情报查询条件
    getCompanySearchHistory(params) {
      return ajax({
        url: 'gt6/search/getSearchHistory',
        method: 'GET',
        params
      })
    },
    // 特易搜搜进入企业详情页获取查询条件
    getCompanyResultSearchHistory(params) {
      return ajax({
        url: 'gt6/search/getCompanySearchHistory',
        method: 'GET',
        params
      })
    },
    //获取公司详情-贸易记录柱状图表 /api/gt/search/getCompanyTradeLogBarChart
    getCompanyTradeLogBarChart(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeLogBarChart',
        method: 'POST',
        data
      })
    },
    //获取公司详情-全部贸易记录图表 /api/gt/search/getAllCompanyTradeLogChart
    getAllCompanyTradeLogChart(data) {
      return ajax({
        url: 'gt6/search/getAllCompanyTradeLogChart',
        method: 'POST',
        data
      })
    },
    //获取已删除的申报关键词
    getDeleteRecommendKeywords(data) {
      return ajax({
        url: 'gt6/search/getDeleteRecommendKeywords',
        method: 'POST',
        data
      })
    },
    //获取已删除的AI近义词和AI行业词
    getRemoveRecommendKeywords(params) {
      return ajax({
        url: 'gt6/public/removedRecommendKeywordsList',
        method: 'GET',
        params
      })
    },
    //删除AI近义词或者AI行业词
    removeRecommendKeywords(data) {
      return ajax({
        url: 'gt6/public/removeRecommendKeywords',
        method: 'POST',
        data
      })
    },
    //恢复已删除的申报关键词
    recoverRecommendKeywords(data) {
      return ajax({
        url: 'gt6/search/recoverRecommendKeywords',
        method: 'POST',
        data
      })
    },
    //恢复已删除的AI近义词或者AI行业词
    recoveryRecommendKeywords(data) {
      return ajax({
        url: 'gt6/public/recoveryRecommendKeywords',
        method: 'POST',
        data
      })
    },
    //获取分享链接接口
    getShareLink(data) {
      return ajax({
        url: 'gt6/search/getShareLink',
        method: 'POST',
        data
      })
    },
    getSearchHistoryDetail(params) {
      return ajax({
        url: 'gt6/search/getSearchHistoryDetail',
        method: 'GET',
        params
      })
    },
    forgetPassword(data) {
      return ajax({
        url: 'business/account/forgetPassword',
        method: 'POST',
        data
      })
    },
    downloadBusinessCompanyList(data) {
      return ajax({
        url: 'gt6/search/downloadBusinessCompanyList',
        method: 'POST',
        data
      })
    },
    getCompanyAddressData(data) {
      return ajax({
        url: 'gt6/search/getCompanyAddressData',
        method: 'POST',
        data
      })
    },
    getCompanySupplierTradeDetail(data) {
      return ajax({
        url: 'gt6/search/getCompanySupplierTradeDetail',
        method: 'POST',
        data
      })
    },
    getImporterCompanyTradeDetail(data) {
      return ajax({
        url: 'gt6/search/getImporterCompanyTradeDetail',
        method: 'POST',
        data
      })
    },
    getExporterCompanyTradeDetail(data) {
      return ajax({
        url: 'gt6/search/getExporterCompanyTradeDetail',
        method: 'POST',
        data
      })
    },
    getSearchKeywordOptions(data) {
      return ajax({
        url: 'gt6/search/getSearchKeywordOptions',
        method: 'POST',
        data
      })
    },
    getCountSummary() {
      return ajax({
        url: 'gt6/search/getCompanyDataSummary',
        method: 'GET'
      })
    },
    getSmartBusiness(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessOpportunities',
        method: 'GET',
        params
      })
    },
    getSearchLabelDetail(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessOpportunityDetail',
        method: 'GET',
        params
      })
    },
    deleteSearchLabel(params) {
      return ajax({
        url: 'gt6/search/deleteSmartBusinessOpportunities',
        method: 'GET',
        params
      })
    },
    saveSearchLabel(data) {
      return ajax({
        url: 'gt6/search/saveSmartBusinessOpportunities',
        method: 'POST',
        data
      })
    },
    // 获取标签 esouData/contact/label
    getContactLabel(params) {
      return ajax({
        url: 'gt6/esouData/contact/label',
        method: 'GET',
      })
    },
    insertContact(data) {
      return ajax({
        url: 'gt6/esouData/insertContact',
        method: 'POST',
        data
      })
    },
    getSearchCounts(data) {
      return ajax({
        url: 'gt6/search/getSearchCounts',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getSearchCounts = e
        })
      })
    },
    searchCompany(data) {
      return ajax({
        url: 'gt6/search/search',
        method: 'POST',
        data
      })
    },
    getHsCodeDetailChart(data) {
      return ajax({
        url: 'gt6/search/getHsCodeChartByCompany',
        method: 'POST',
        data
      })
    },
    getHsCodeDetailTable(data) {
      return ajax({
        url: 'gt6/search/getHsCodeTableByCompany',
        method: 'POST',
        data
      })
    },
    getIntelligenceSupplierTable(data) {
      return ajax({
        url: 'gt6/ai/searchCompanyAnalysis',
        method: 'POST',
        data
      })
    },
    getSearchProductData(data) {
      return ajax({
        url: 'gt6/ai/searchProductData',
        method: 'POST',
        data
      })
    },
    getBusinessDownInfo(params) {
      return ajax({
        url: 'gt6/search/getBusinessDownInfo',
        method: 'GET',
        params
      })
    },
    getSmartBusinessDownInfo(params) {
      return ajax({
        url: 'gt6/search/getSmartBusinessDownInfo',
        method: 'GET',
        params
      })
    },
    getResultCount(data) {
      return ajax({
        url: 'gt6/search/getResultCount',
        method: 'POST',
        data
      })
    },
    getResultCountryOptions(data) {
      return ajax({
        url: 'gt6/search/getResultCountryOptions',
        method: 'POST',
        data
      })
    },
    checkDownload(data) {
      return ajax({
        url: 'gt6/search/getDownloadInfo',
        method: 'POST',
        data
      })
    },
    download(data) {
      return ajax({
        url: 'gt6/search/downloadCompanyList',
        method: 'POST',
        data
      })
    },
    excludeItems(params) {
      return ajax({
        url: 'gt6/search/excludeItems',
        method: 'GET',
        params
      })
    },
    // getSupplierList(data) {
    //   return ajax({
    //     url: 'gt6/search/getSupplierList',
    //     method: 'POST',
    //     data
    //   })
    // },
    // getChineseBuyerList(data) {
    //   return ajax({
    //     url: 'gt6/search/getChineseFraternityBuyerList',
    //     method: 'POST',
    //     data
    //   })
    // },
    searchByProductAndHsCode(data) {
      return ajax({
        url: 'gt6/search/searchByProductAndHsCode',
        method: 'POST',
        data
      })
    },
    searchByProductAndHsCodeAi(data) {
      return ajax({
        url: 'gt6/ai/searchByProductAndHsCodeAi',
        method: 'POST',
        data
      })
    },
    searchKeywordAndHsCodeData(data) {
      return ajax({
        url: 'gt6/ai/searchKeywordAndHsCodeData',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.searchKeywordAndHsCodeData = e
        })
      })
    },
    searchBuyersByCompany(data) {
      return ajax({
        url: 'gt6/search/searchByCompany',
        method: 'POST',
        data
      })
    },
    searchByVol(data) {
      return ajax({
        url: 'gt6/search/searchByVol',
        method: 'POST',
        data
      })
    },
    // detail
    getCompanyDetail(params) {
      return ajax({
        url: 'gt6/search/getCompanyDetail',
        method: 'GET',
        params
      })
    },
    getCompanyTradeDetailTable(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeDetailTable',
        method: 'POST',
        data
      })
    },
    getCompanyTradeDetailChartData(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeDetailChartData',
        method: 'POST',
        data
      })
    },
    getCompanySupplierAnalysisTable(data) {
      return ajax({
        url: 'gt6/search/getCompanySupplierAnalysisTable',
        method: 'POST',
        data
      })
    },
    // 采购商国家列表
    getCompanyBuyerAnalysisTableForCompany(data) {
      return ajax({
        url: 'gt6/search/getCompanyBuyerAnalysisCompany',
        method: 'POST',
        data
      })
    },
    // 供应商分析国家列表
    getCompanySupplierAnalysisTableForCompany(data) {
      return ajax({
        url: 'gt6/search/getCompanySupplierAnalysisCompany',
        method: 'POST',
        data
      })
    },
    getCompanySupplierAnalysisChart(data) {
      return ajax({
        url: 'gt6/search/getCompanySupplierAnalysisChart',
        method: 'POST',
        data
      })
    },
    getCompanyBuyerAnalysisTable(data) {
      return ajax({
        url: 'gt6/search/getCompanyBuyerAnalysisTable',
        method: 'POST',
        data
      })
    },
    getCompanyBuyerAnalysisChart(data) {
      return ajax({
        url: 'gt6/search/getCompanyBuyerAnalysisChart',
        method: 'POST',
        data
      })
    },
    getCompanyTradeProductData(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeProductData',
        method: 'POST',
        data
      })
    },
    getCompanyTradeProductTable(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeProductTable',
        method: 'POST',
        data
      })
    },
    getCompanyTradePortTable(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradePortAnalysisTable',
        method: 'POST',
        data
      })
    },
    getCompanyTradePortChart(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradePortAnalysisChart',
        method: 'POST',
        data
      })
    },
    getCompanyTradeLogTable(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeLogAnalysisTable',
        method: 'POST',
        data
      })
    },
    getCompanyTradeLogColumn(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeLogAnalysisTableColumn',
        method: 'POST',
        data
      })
    },
    getCompanyTradeLogChart(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeLogChart',
        method: 'POST',
        data
      })
    },
    getCompanyGoodsInformation(params) {
      return ajax({
        url: 'gt6/search/getCompanyGoodsInformation',
        method: 'GET',
        params
      })
    },
    // 获取公司详情-企业联系人数据
    getCompanyContacts(data) {
      return ajax({
        url: 'gt6/search/getCompanyContacts',
        method: 'POST',
        data
      })
    },
    // 获取绑定的易搜企业列表
    getCompanySouDomain(data) {
      return ajax({
        url: 'gt6/search/getCompanySouDomain',
        method: 'POST',
        data
      })
    },
    delSouCompanyRel(data) {
      return ajax({
        url: 'gt6/search/delSouCompanyRel',
        method: 'POST',
        data
      })
    },
    getCompanyTradeLinksData(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeLinksData',
        method: 'POST',
        data
      })
    },
    // getCompanyTradeLinksData(data) {
    //   return ajax({
    //     url: 'gt6/search/getCompanyTradeLinksData',
    //     method: 'POST',
    //     data
    //   })
    // },
    getCompanyTradeOriginCountryOptions(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeOriginCountryOptions',
        method: 'POST',
        data
      })
    },
    getCompanyTradeHsCodeOptions(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeHsCodeOptions',
        method: 'POST',
        data
      })
    },
    getCompanyTradeProductKeywordOptions(data) {
      return ajax({
        url: 'gt6/search/getCompanyTradeProductKeywordOptions',
        method: 'POST',
        data
      })
    },
    collectCompany(data) {
      return ajax({
        url: 'gt6/search/collectCompany',
        method: 'POST',
        data
      })
    },
    editCollectLabel(data) {
      return ajax({
        url: 'gt6/search/editCollectLabel',
        method: 'POST',
        data
      })
    },
    cancelCollectCompany(data) {
      return ajax({
        url: 'gt6/search/cancelCollectCompany',
        method: 'POST',
        data
      })
    },
    downloadCompanyReport(data) {
      return ajax({
        url: 'gt6/search/downloadCompanyReport',
        method: 'POST',
        data
      })
    },
    getRecommendKeyword(data) {
      return ajax({
        url: 'gt6/search/getRecommendKeywords',
        method: 'POST',
        data
      })
    },
    mergeCompany(data) {
      return ajax({
        url: 'gt6/search/mergeCompany',
        method: 'POST',
        data
      })
    },
    getMergeCompanyList(params) {
      return ajax({
        url: 'gt6/search/getMergeCompanyList',
        method: 'GET',
        params
      })
    },
    getDataSourceOptions(params) {
      return ajax({
        url: 'gt6/search/getCompanyDataSourceOptions',
        method: 'GET',
        params
      })
    },
    getCompanySourceTypeOption(data) {
      return ajax({
        url: 'gt6/search/getCompanySourceTypeOption',
        method: 'POST',
        data
      })
    },
    deleteExportCompanyLog(params) {
      return ajax({
        url: 'gt6/search/deleteExportCompanyLog',
        method: 'GET',
        params
      })
    },
    subscribeCompany(data) {
      return ajax({
        url: 'gt6/search/subscribeCompany',
        method: 'POST',
        data
      })
    },
    changeCompanyPersonal(params) {
      return ajax({
        url: 'gt6/search/changeCompanyPersonal',
        method: 'GET',
        params
      })
    },
    getSmartBusinessPage(data) {
      return ajax({
        url: 'gt6/search/getSmartBusinessPage',
        method: 'POST',
        data
      })
    },
    deleteSmartBusiness(params) {
      return ajax({
        url: 'gt6/search/deleteSmartBusiness',
        method: 'GET',
        params
      })
    },
    smartBusinessTop(params) {
      return ajax({
        url: 'gt6/search/smartBusinessTop',
        method: 'GET',
        params
      })
    },
    subscribeSmartBusinessOpportunity(data) {
      return ajax({
        url: 'gt6/search/subscribeSmartBusinessOpportunity',
        method: 'POST',
        data
      })
    }
  },
  trade: {
    // 贸易情报按钮布局
    getTableLayout(params) {
      return ajax({
        url: `gt6/trade/getTableLayout`,
        method: 'GET',
        params
      })
    },
    setTableLayout(data) {
      return ajax({
        url: 'gt6/trade/tableLayout',
        method: 'POST',
        data
      })
    },
    getAiRecommendKeywords(data) {
      return ajax({
        url: 'gt6/public/getRecommendKeywords',
        method: 'POST',
        data
      })
    },
    // 添加通用配置数据接口
    getCustomConfig(data) {
      return ajax({
        url: `gt6/public/getCustomConfig?key=${data}`,
        method: 'GET',
      })
    },
    // 查询排除数据源
    getDuplicateSource() {
      return ajax({
        url: 'gt6/public/duplicateSource/list',
        method: 'GET'
      })
    },
    // /api/gt/trade/resetCustomColumn 重置自定义列
    resetCustomColumn(data) {
      return ajax({
        url: 'gt6/trade/resetCustomColumn',
        method: 'POST',
        data
      })
    },
    // /api/gt/trade/checkCompanyAnalysis 新增采购商/供应商
    checkCompanyAnalysis(data) {
      return ajax({
        url: 'gt6/trade/checkCompanyAnalysis',
        method: 'POST',
        data
      })
    },
    // /api/gt/trade/getSearchFiled 获取外显字段数据
    getSearchFiled(params) {
      return ajax({
        url: 'gt6/trade/getSearchFiled',
        method: 'GET',
        params
      })
    },
    // /api/gt/trade/saveSearchFiled 保存外显字段配置
    saveSearchFiled(data) {
      return ajax({
        url: 'gt6/trade/saveSearchFiled',
        method: 'POST',
        data
      })
    },
    // 获取hs编码图表 /api/gt/trade/getHsCodeAnalysisTable
    getHsCodeAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getHsCodeAnalysisTable',
        method: 'POST',
        data
      })
    },
    getHsCodeAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getHsCodeAnalysisChart',
        method: 'POST',
        data
      })
    },
    // 保存自动翻译修改的数据 /api/gt/trade/saveTranslateVal
    saveTranslateVal(data) {
      return ajax({
        url: 'gt6/trade/saveTranslateVal',
        method: 'POST',
        data
      })
    },
    // 获取时间锁定状态 /api/gt/trade/getTimeLocked
    getTimeLocked() {
      return ajax({
        url: 'gt6/trade/getTimeLocked',
        method: 'GET'
      })
    },
    // 修改时间锁定状态 /api/gt/trade/updateTimeLocked
    updateTimeLocked(params) {
      return ajax({
        url: 'gt6/trade/updateTimeLocked',
        method: 'GET',
        params
      })
    },
    // 收藏提单 /api/gt/trade/getBiButton
    getBiButton(params) {
      return ajax({
        url: 'gt6/trade/getBiButton',
        method: 'GET',
        params
      })
    },
    // 根据国家获取报告数据 /api/gt/analysisReport/getReportByCountryId
    getReportByCountryId(data) {
      return ajax({
        url: 'gt6/analysisReport/getReportByCountryId',
        method: 'POST',
        data
      })
    },
    // 获取报告跳转按钮 /api/gt/analysisReport/getSkipButton
    getSkipButton(data) {
      return ajax({
        url: 'gt6/analysisReport/getSkipButton',
        method: 'POST',
        data
      })
    },
    // 收藏提单 /api/gt/trade/billCollect
    billCollect(data) {
      return ajax({
        url: 'gt6/trade/billCollect',
        method: 'POST',
        data
      })
    },
    // 获取收藏提单数据 /api/gt/trade/getBillCollect
    getBillCollect(data) {
      return ajax({
        url: 'gt6/trade/getBillCollect',
        method: 'POST',
        data
      })
    },
    // 收藏提单置顶、取消置顶 /api/gt/trade/pinnedBillCollect
    pinnedBillCollect(data) {
      return ajax({
        url: 'gt6/trade/pinnedBillCollect',
        method: 'POST',
        data
      })
    },
    // 获取多国家工商数据 /api/gt/public/getIcData
    getIcData(data) {
      return ajax({
        url: 'gt6/public/getIcData',
        method: 'POST',
        data
      })
    },
    //查看更多贸易情报数据
    getMoreData(data) {
      return ajax({
        url: 'gt6/trade/getBusinessByKey',
        method: 'POST',
        data
      })
    },
    //批量获取翻译接口
    getTranslateBath(data) {
      return ajax({
        url: 'gt6/public/getTranslateBath',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getTranslateBath = e
        })
      })
    },
    //获取当前语种的接口
    getTranslateLanguage(params) {
      return ajax({
        url: 'gt6/public/getTranslateLanguage',
        method: 'GET',
        params
      })
    },
    //获取分享链接接口
    getShareLink(data) {
      return ajax({
        url: 'gt6/trade/getShareLink',
        method: 'POST',
        data
      })
    },
    //自定义表头
    customerTableHeader(data) {
      return ajax({
        url: '/gt6/trade/getCustomerColumnList',
        method: 'POST',
        data
      })
    },
    //自定义表格
    customerTable(data) {
      return ajax({
        url: 'gt6/trade/insertCustomerColumn',
        method: 'POST',
        data
      })
    },
    //获取贸易数据
    tradeSearchCount(data) {
      return ajax({
        url: 'gt6/trade/getPreSearchCount',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.tradePreSearchCount = e
        })
      })
    },
    //获取贸易数据
    getPreSearchCountOld(data) {
      return ajax({
        url: 'gt6/trade/getPreSearchCountOld',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getPreSearchCountOld = e
        })
      })
    },
    // 获取原产国数据 /api/gt/trade/getOriginCountrys
    getOriginCountrys(params) {
      return ajax({
        url: 'gt6/trade/getOriginCountrys',
        method: 'GET'
      })
    },
    // 获取数量单位数据 /api/gt/trade/getQuantiyUnits
    getQuantiyUnits(params) {
      return ajax({
        url: 'gt6/trade/getQuantiyUnits',
        method: 'GET'
      })
    },
    getColumns(params) {
      return ajax({
        url: 'gt6/trade/getTableListColumns',
        method: 'GET',
        params,
        cancelToken: new CancelToken((e) => {
          window.cancel.getTableListColumns = e
        })
      })
    },
    getCountSummary() {
      return ajax({
        url: 'gt6/trade/getTradeDataSummary',
        method: 'GET'
      })
    },
    getSearchLabel(params) {
      return ajax({
        url: 'gt6/trade/getSearchLabelList',
        method: 'GET',
        params
      })
    },
    saveSearchLabel(data) {
      return ajax({
        url: 'gt6/trade/saveSearchLabel',
        method: 'POST',
        data
      })
    },
    getSearchLabelDetail(params) {
      return ajax({
        url: 'gt6/trade/getSearchLabelDetail',
        method: 'GET',
        params
      })
    },
    getSearchHistoryDetail(params) {
      return ajax({
        url: 'gt6/search/getSearchHistoryDetail',
        method: 'GET',
        params
      })
    },
    deleteSearchLabel(params) {
      return ajax({
        url: 'gt6/trade/deleteSearchLabel',
        method: 'GET',
        params
      })
    },
    getFiltersOptions(data) {
      return ajax({
        url: 'gt6/trade/getFiltersOptions',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getFiltersOptions = e
        })
      })
    },
    getTabList(data) {
      return ajax({
        url: 'gt6/trade/getTableTabs',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getTableTabs = e
        })
      })
    },
    //获取tabs 包含的的count 数据
    getTabCount(data) {
      return ajax({
        url: 'gt6/trade/getTableTabsCount',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getTableTabsCount = e
        })
      })
    },
    getResultCountryOptions(data) {
      return ajax({
        url: 'gt6/trade/getResultCountryOptions',
        method: 'POST',
        data
      })
    },
    getTableList(data) {
      return ajax({
        url: 'gt6/trade/getTableList',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getTradeTableList = e
        })
      })
    },
    getMarketTrendAnalysis(data) {
      return ajax({
        url: 'gt6/trade/getMarketTrendAnalysis',
        method: 'POST',
        data
      })
    },
    // 获取年月折线图和折柱图 /api/gt/trade/getAllMarketTrendAnalysis
    getAllMarketTrendAnalysis(data) {
      return ajax({
        url: 'gt6/trade/getAllMarketTrendAnalysis',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e) => {
          window.cancel.getAllMarketTrendAnalysis = e
        })
      })
    },
    getMarketTrendAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getMarketTrendAnalysisTable',
        method: 'POST',
        data
      })
    },
    getCountryAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getCountryAnalysisChart',
        method: 'POST',
        data
      })
    },
    getCountryAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getCountryAnalysisTable',
        method: 'POST',
        data
      })
    },
    getBuyerAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getBuyerAnalysisTable',
        method: 'POST',
        data
      })
    },
    getBuyerAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getBuyerAnalysisChart',
        method: 'POST',
        data
      })
    },
    getSupplierAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getSupplierAnalysisChart',
        method: 'POST',
        data
      })
    },
    getSupplierAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getSupplierAnalysisTable',
        method: 'POST',
        data
      })
    },
    getBrandAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getBrandAnalysisChart',
        method: 'POST',
        data
      })
    },
    getBrandAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getBrandAnalysisTable',
        method: 'POST',
        data
      })
    },
    getAveragePriceAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getAveragePriceAnalysisChart',
        method: 'POST',
        data
      })
    },
    getAveragePriceAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getAveragePriceAnalysisTable',
        method: 'POST',
        data
      })
    },
    getDeparturePortAnalysisChart(data) {
      return ajax({
        url: 'gt6/trade/getDeparturePortAnalysisChart',
        method: 'POST',
        data
      })
    },
    getDeparturePortAnalysisTable(data) {
      return ajax({
        url: 'gt6/trade/getDeparturePortAnalysisTable',
        method: 'POST',
        data
      })
    },
    getTradeDetail(data) {
      return ajax({
        url: 'gt6/trade/getTradeDetail',
        method: 'POST',
        data
      })
    },
    checkDownload(data) {
      return ajax({
        url: 'gt6/search/getDownloadInfo',
        method: 'POST',
        data
      })
    },
    download(data) {
      return ajax({
        url: 'gt6/search/downloadTradeData',
        method: 'POST',
        data
      })
    },
    deleteDownloadTradeDataLog(params) {
      return ajax({
        url: 'gt6/trade/deleteDownloadTradeDataLog',
        method: 'GET',
        params
      })
    },
    // 数据源 数据为0时
    getTableTabsCountByTypes(data) {
      return ajax({
        url: 'gt6/trade/getTableTabsCountByTypes',
        method: 'POST',
        data
      })
    },
  },
  product: {
    // 根据国家获取数据源 /api/gt/public/getSourceTypeByCountryId
    getSourceTypeByCountryId(params) {
      return ajax({
        url: 'gt6/public/getSourceTypeByCountryId',
        method: 'GET',
        params
      })
    },
    getProductTags() {
      return ajax({
        url: 'gt6/product/getProductDataTags',
        method: 'GET'
      })
    },
    getProductTabData() {
      return ajax({
        url: 'gt6/product/getProductTabData',
        method: 'GET'
      })
    },
    getProductList(params) {
      return ajax({
        url: 'gt6/product/getProductList',
        method: 'GET',
        params
      })
    },
    getProductAnalysisExportData(params) {
      return ajax({
        url: 'gt6/product/getProductAnalysisExportData',
        method: 'GET',
        params
      })
    },
    saveProductAnalysis(data) {
      return ajax({
        url: 'gt6/product/saveProductAnalysis',
        method: 'POST',
        data
      })
    },
    deleteProductAnalysis(params) {
      return ajax({
        url: 'gt6/product/deleteProductAnalysis',
        method: 'GET',
        params
      })
    },
    getDetail(params) {
      return ajax({
        url: 'gt6/product/getDetail',
        method: 'GET',
        params
      })
    },
    getFiltersOptions(data) {
      return ajax({
        url: 'gt6/product/getFiltersOptions',
        method: 'POST',
        data
      })
    },
    //获取左边选项的时间
    getFiltersOptionsTimes(data) {
      return ajax({
        url: 'gt6/product/getFiltersOptionsTimes',
        method: 'POST',
        data
      })
    },
    getIeAnalysisChart(data) {
      return ajax({
        url: 'gt6/product/getIeAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIeAnalysisTable(data) {
      return ajax({
        url: 'gt6/product/getIeAnalysisTable',
        method: 'POST',
        data
      })
    },
    getProductMarketAnalysisTrend(data) {
      return ajax({
        url: 'gt6/product/getProductMarketAnalysisTrend',
        method: 'POST',
        data
      })
    },
    getBuyerAnalysisChart(data) {
      return ajax({
        url: 'gt6/product/getBuyerAnalysisChart',
        method: 'POST',
        data
      })
    },
    getBuyerAnalysisTable(data) {
      return ajax({
        url: 'gt6/product/getBuyerAnalysisTable',
        method: 'POST',
        data
      })
    },
    getSupplierAnalysisChart(data) {
      return ajax({
        url: 'gt6/product/getSupplierAnalysisChart',
        method: 'POST',
        data
      })
    },
    getSupplierAnalysisTable(data) {
      return ajax({
        url: 'gt6/product/getSupplierAnalysisTable',
        method: 'POST',
        data
      })
    },
    getPortAnalysisChart(data) {
      return ajax({
        url: 'gt6/product/getPortAnalysisChart',
        method: 'POST',
        data
      })
    },
    getPortAnalysisTable(data) {
      return ajax({
        url: 'gt6/product/getPortAnalysisTable',
        method: 'POST',
        data
      })
    },
    productSubscription(params) {
      return ajax({
        url: 'gt6/product/productSubscription',
        method: 'GET',
        params
      })
    },
    downloadProductAnalysis(data) {
      return ajax({
        url: 'gt6/search/downloadProductAnalysis',
        method: 'POST',
        data
      })
    },
    getReportDownloadInfo(data) {
      return ajax({
        url: 'gt6/search/getReportDownloadInfo',
        method: 'POST',
        responseType: 'blob',
        data
      })
    },
    getProductChangeHsCode(data) {
      return ajax({
        url: 'gt6/product/getProductChangeHsCode',
        method: 'POST',
        data
      })
    },
    getResultCountryOptions(data) {
      return ajax({
        url: 'gt6/product/getResultCountryOptions',
        method: 'POST',
        data
      })
    }
  },
  trend: {
    getSummaryData() {
      return ajax({
        url: 'gt6/trend/getTrendSummary',
        method: 'GET'
      })
    },
    getList(params) {
      return ajax({
        url: 'gt6/trend/getList',
        method: 'GET',
        params
      })
    },
    saveTrendAnalysis(data) {
      return ajax({
        url: 'gt6/trend/saveTrendAnalysis',
        method: 'POST',
        data
      })
    },
    saveTrendAnalysis1(data) {
      return ajax({
        url: 'gt6/trendChina/saveTrendAnalysis',
        method: 'POST',
        data
      })
    },
    deleteAnalysis(params) {
      return ajax({
        url: 'gt6/trend/deleteAnalysis',
        method: 'GET',
        params
      })
    },
    getAnalysisIndustryDetail(params) {
      return ajax({
        url: 'gt6/trend/getAnalysisIndustryDetail',
        method: 'GET',
        params
      })
    },
    getAnalysisIndustryDetail1(params) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisIndustryDetail',
        method: 'GET',
        params
      })
    },
    getAnalysisMarketDetail(params) {
      return ajax({
        url: 'gt6/trend/getAnalysisMarketDetail',
        method: 'GET',
        params
      })
    },
    subscribeAnalysis(params) {
      return ajax({
        url: 'gt6/trend/subscribeAnalysis',
        method: 'GET',
        params
      })
    },
    subscribeAnalysis1(params) {
      return ajax({
        url: 'gt6/trendChina/subscribeAnalysis',
        method: 'GET',
        params
      })
    },
    downloadAnalysis(data) {
      return ajax({
        url: 'gt6/search/downloadTrendAnalysis',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisTrend(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisTrendChart',
        method: 'POST',
        data
      })
    },
    // 获取HS编码细分项排名TOP100表格
    getMarketAnalysisHsCodeTabel(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisHsCodeTabel',
        method: 'POST',
        data
      })
    },
    // 获取HS编码细分项排名TOP100图表
    getMarketAnalysisHsCodeChart(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisHsCodeChart',
        method: 'POST',
        data
      })
    },
    // 获取市场维度贸易伙伴表格
    getMarketAnalysisPartnerTable(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisPartnerTable',
        method: 'POST',
        data
      })
    },
    // 获取市场维度贸易伙伴分析图表
    getMarketAnalysisPartnerChart(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisPartnerChart',
        method: 'POST',
        data
      })
    },
    // 获取市场维度表单视图
    getMarketAnalysisFromTable(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisFromTable',
        method: 'POST',
        data
      })
    },
    //获取贸易伙伴
    getMarketAnalysisFilter(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisFilter',
        method: 'POST',
        data
      })
    },
    // 获取市场维度贸易伙伴分布趋势表格
    getMarketAnalysisPartnerAreaTable(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisPartnerAreaTable',
        method: 'POST',
        data
      })
    },
    // 获取市场维度HS编码分析行业类型
    getMarketAnalysisHsCodeIndustry(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisHsCodeIndustry',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e)=>{
          window.cancel.getMarketAnalysisHsCodeIndustry = e
        })
      })
    },
    // 获取市场维度统计数据
    getAnalysisMarketSummaryData(data) {
      return ajax({
        url: 'gt6/trend/getAnalysisMarketSummaryData',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisProductSummaryData(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisProductSummaryData',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisProductChart(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisProductChart',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisProductCountryChart(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisProductCountryChart',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisAreaTrendData(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisAreaTrendData',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisAreaTrendTable(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisAreaTrendTable',
        method: 'POST',
        data
      })
    },
    getMarketAnalysisProductRelation(data) {
      return ajax({
        url: 'gt6/trend/getMarketAnalysisProductRelation',
        method: 'POST',
        data
      })
    },
    getIndustryAreaAnalysisChart(data) {
      return ajax({
        url: 'gt6/trend/getIndustryAreaAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIndustryAreaAnalysisChart1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryAreaAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIndustryAreaAnalysisTable(data) {
      return ajax({
        url: 'gt6/trend/getIndustryAreaAnalysisTable',
        method: 'POST',
        data
      })
    },
    getIndustryAreaAnalysisTable1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryAreaAnalysisTable',
        method: 'POST',
        data
      })
    },
    getIndustryMarketTrendAnalysisChart(data) {
      return ajax({
        url: 'gt6/trend/getIndustryMarketTrendAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIndustryMarketTrendAnalysisChart1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryMarketTrendAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIndustryMarketTrendAnalysisTable(data) {
      return ajax({
        url: 'gt6/trend/getIndustryMarketTrendAnalysisTable',
        method: 'POST',
        data
      })
    },
    getIndustryMarketTrendAnalysisTable1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryMarketTrendAnalysisTable',
        method: 'POST',
        data
      })
    },
    getIndustryTradeAnalysisTable(data) {
      return ajax({
        url: 'gt6/trend/getIndustryTradeAnalysisTable',
        method: 'POST',
        data
      })
    },
    getIndustryTradeAnalysisData(data) {
      return ajax({
        url: 'gt6/trend/getIndustryTradeAnalysisData',
        method: 'POST',
        data
      })
    },
    getIndustryTradeAnalysisData1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryTradeAnalysisData',
        method: 'POST',
        data
      })
    },
    getIndustryMarketShareTrendAnalysisChart(data) {
      return ajax({
        url: 'gt6/trend/getIndustryMarketShareTrendAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIndustryMarketShareTrendAnalysisChart1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryMarketShareTrendAnalysisChart',
        method: 'POST',
        data
      })
    },
    getIndustryTradeAnalysisTable(data) {
      return ajax({
        url: 'gt6/trend/getIndustryTradeAnalysisTable',
        method: 'POST',
        data
      })
    },
    checkTrendAnalysis(data) {
      return ajax({
        url: 'gt6/trend/checkTrendAnalysis',
        method: 'POST',
        data
      })
    },
    getIndustryTradeAnalysisTable1(data) {
      return ajax({
        url: 'gt6/trendChina/getIndustryTradeAnalysisTable',
        method: 'POST',
        data
      })
    },
    getAnalysisAvgPriceTable(data) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisAvgPriceTable',
        method: 'POST',
        data
      })
    },
    getAnalysisAvgPriceChar(data) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisAvgPriceChar',
        method: 'POST',
        data
      })
    },
    getMonthAnalysis(data) {
      return ajax({
        url: 'gt6/trendChina/getMonthAnalysis',
        method: 'POST',
        data
      })
    },
    getContraryAnalysis(data) {
      return ajax({
        url: 'gt6/trendChina/getContraryAnalysis',
        method: 'POST',
        data
      })
    },
    getContinentAnalysis(data) {
      return ajax({
        url: 'gt6/trendChina/getContinentAnalysis',
        method: 'POST',
        data
      })
    },
    getDestinationAnalysis(data) {
      return ajax({
        url: 'gt6/trendChina/getDestinationAnalysis',
        method: 'POST',
        data
      })
    },
    getOriginAnalysis(data) {
      return ajax({
        url: 'gt6/trendChina/getOriginAnalysis',
        method: 'POST',
        data
      })
    },
    //目的地地分析二级数据的加载
    getDestinationAnalysisSub(data) {
      return ajax({
        url: 'gt6/trendChina/getDestinationAnalysisSub',
        method: 'POST',
        data
      })
    },
    //原产地分析二级数据的加载
    getOriginAnalysisSub(data) {
      return ajax({
        url: 'gt6/trendChina/getOriginAnalysisSub',
        method: 'POST',
        data
      })
    },
    tableExport(data) {
      return ajax({
        url: 'gt6/trendChina/tableExport',
        method: 'POST',
        data
      })
    },
    getTradeCountry() {
      return ajax({
        url: 'gt6/trendChina/getTradeCountry',
        method: 'GET',
      })
    },
    getTradeType() {
      return ajax({
        url: 'gt6/trendChina/getTradeType',
        method: 'GET',
      })
    },
    getAnalysisAvgPriceCountrys(data) {
      return ajax({
        url: 'gt6/trendChina/getAnalysisAvgPriceCountrys',
        method: 'POST',
        data
      })
    },
    getAnalysisCountrys(data) {
      return ajax({
        url: 'gt6/trendChina/listCountryNameByTrendCondition',
        method: 'POST',
        data
      })
    },
    // 中国专属市场趋势概况 - 主详情 /api/gt/trendChina/getMarketDetails?
    getMarketDetails(params) {
      return ajax({
        url: 'gt6/trendChina/getMarketDetails',
        method: 'GET',
        params
      })
    },
    // 中国专属市场趋势概况 - 月度趋势 /api/gt/trendChina/getMarketMonth
    getMarketMonth(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketMonth',
        method: 'POST',
        data
      })
    },
    // 中国专属市场趋势概况 - 总览 /api/gt/trendChina/getMarketSummary
    getMarketSummary(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketSummary',
        method: 'POST',
        data
      })
    },
    // 中国专属市场趋势概况 -国家列表 /api/gt/trendChina/getMarketCity
    getMarketCity() {
      return ajax({
        url: 'gt6/trendChina/getMarketCity',
        method: 'GET'
      })
    },
    // 中国专属市场趋势概况 - 贸易伙伴&省份表格 /api/gt/trendChina/getMarketPartnerTable
    getMarketPartnerTable(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketPartnerTable',
        method: 'POST',
        data
      })
    },
    //中国专属市场趋势概况 - 贸易伙伴&省份图表 /api/gt/trendChina/getMarketPartnerChart
    getMarketPartnerChart(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketPartnerChart',
        method: 'POST',
        data
      })
    },
    //中国专属市场趋势概况 - hs编码图表 /api/gt/trendChina/getMarketHsChart
    getMarketHsChart(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketHsChart',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e)=>{
          window.cancel.getMarketHsChart = e
        })
      })
    },
    //中国专属市场趋势概况- hs编码表格 /api/gt/trendChina/getMarketHsTable
    getMarketHsTable(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketHsTable',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e)=>{
          window.cancel.getMarketHsTable = e
        })
      })
    },
    // 获取市场维度HS编码分析行业类型/api/gt/trendChina/getMarketAnalysisHsCodeIndustry  
    getChinaMarketAnalysisHsCodeIndustry(data) {
      return ajax({
        url: 'gt6/trendChina/getMarketAnalysisHsCodeIndustry',
        method: 'POST',
        data,
        cancelToken: new CancelToken((e)=>{
          window.cancel.getChinaMarketAnalysisHsCodeIndustry = e
        })
      })
    },
  },
  report: {
    getCompanyDetailReportData(data) {
      return ajax({
        url: 'gt6/report/getCompanyDetailReportData',
        method: 'POST',
        data
      })
    },
    getChinaTrendAnalysisData(params) {
      return ajax({
        url: 'gt6/trendChina/getChinaTrendAnalysisData',
        method: 'GET',
        params,
        notHaveToken: true
      })
    },
    getProductReport(data) {
      return ajax({
        url: 'gt6/report/getProductReport',
        method: 'POST',
        data
      })
    },
    getTrendIndustryReport(data) {
      return ajax({
        url: 'gt6/report/getTrendIndustryReport',
        method: 'POST',
        data
      })
    },
    getChapter1(params) {
      return ajax({
        url: 'gt6/bi/export/getChapter1',
        method: 'GET',
        params
      })
    },
    getChapter2(params) {
      return ajax({
        url: 'gt6/bi/export/getChapter2',
        method: 'GET',
        params
      })
    },
    getChapter3(params) {
      return ajax({
        url: 'gt6/bi/export/getChapter3',
        method: 'GET',
        params
      })
    },
    getChapter4(params) {
      return ajax({
        url: 'gt6/bi/export/getChapter4',
        method: 'GET',
        params
      })
    },
    getChapter5(params) {
      return ajax({
        url: 'gt6/bi/export/getChapter5',
        method: 'GET',
        params
      })
    },
    getChapter6(params) {
      return ajax({
        url: 'gt6/bi/export/getChapter6',
        method: 'GET',
        params
      })
    },
  },
  analysis: {
    ...analysisApi
  },
  aiIntelligence: {
    ...aiIntelligence
  },
  logs: {
    postCustomerLogs(data) {
      return customerAjax({
        url: 'log/AddLog',
        method: 'POST',
        data
      })
    },
    // /api/data/log/logdata/asyn/addWebLogs
    addWebLogs(data) {
      return logAjax({
        url: 'log/logdata/addWebLogs',
        method: 'POST',
        data
      })
    },

  },
  business: {
    ...businessApi,
    getPageList(data) {
      return ajax({
        url: 'gt6/businessCompanySearch/getPageList',
        method: 'POST',
        data
      })
    },
    //国家列表
    getCountryOptions(params) {
      return ajax({
        url: 'gt6/businessCompanySearch/getCountryOptions',
        method: 'GET',
        params
      })
    },
    //获取企业类型。
    getCompanyTypes(params) {
      return ajax({
        url: 'gt6/businessCompanySearch/getCompanyTypes',
        method: 'GET',
        params
      })
    },
    //获取企业详情
    getCompanyDetail(params) {
      return ajax({
        url: 'gt6/businessCompanyDetail/getCompanyDetail',
        method: 'GET',
        params
      })
    },
    //智能商机保存
    //   {
    //     "id":0,//商机ID （修改时用）
    //     "name":"商业数据智能商机列表",//保存时商机名称
    //     "parment":"其它参数传参方式和特易搜搜保持一致"
    // }
    saveSmartBusinessOpportunities(data) {
      return ajax({
        url: 'gt6/businessCompanySearch/saveSmartBusinessOpportunities',
        method: 'POST',
        data
      })
    },
    //获取商机列表
    getSmartBusinessOpportunities(params) {
      return ajax({
        url: 'gt6/businessCompanySearch/getSmartBusinessOpportunities',
        method: 'GET',
        params
      })
    },
    //智能商机删除
    deleteSmartBusinessOpportunities(params) {
      return ajax({
        url: 'gt6/businessCompanySearch/deleteSmartBusinessOpportunities',
        method: 'GET',
        params
      })
    },
    //智能商机查看
    getSmartBusinessOpportunityDetail(params) {
      return ajax({
        url: 'gt6/businessCompanySearch/getSmartBusinessOpportunityDetail',
        method: 'GET',
        params
      })
    },
    //获取企业详情联系人接口
    getCompanyContacts(params) {
      return ajax({
        url: 'gt6/businessCompanyDetail/getCompanyContacts',
        method: 'GET',
        params
      })
    },
    //查看历史纪录接口
    getHistorySearchList(params) {
      return ajax({
        url: 'gt6/search/getHistorySearchList',
        method: 'GET',
        params
      })
    },
    //获取行业分类数据
    getIndustryCategory(params) {
      return ajax({
        url: 'gt6/businessCompanySearch/getIndustryCategory',
        method: 'GET',
        params
      })
    },
    //获取商业数据查询总数
    getResultCount(data) {
      return ajax({
        url: 'gt6/businessCompanySearch/getResultCount',
        method: 'POST',
        data
      })
    }
  },
  help: {
    // 帮助中心列表
    getProductHelpList(data) {
      return ajax({
        url: 'help/public/getProductHelperData',
        method: 'post',
        data
      })
    },
    //获取当前消息
    getChatMessage(data) {
      return ajax({
        url: 'help/chat/sendMsg',
        method: 'POST',
        data
      })
    },
    getHistoryPage(data) {
      return ajax({
        url: 'help/chat/getHistoryPage',
        method: 'POST',
        data
      })
    },
    //记录访问时长
    saveViewTime(data) {
      return ajax({
        url: 'help/public/saveViewTime',
        method: 'POST',
        data
      })
    },
    // // 帮助中心详情
    // getProductHelpInfo(data){
    //   return ajax({
    //     url: 'help/public/getProductHelpInfo?id=' + data,
    //     method: 'get'
    //   })
    // }
  },
  cantonFair: {
    ...CantonFairApi
  },
  credit: {
    ...CreditApi
  },
  ai: {
    ...AIGPT
  }
}
